import { supabase } from '../lib/supabase';

/**
 * Refreshes the database schema by making a simple query to each table
 * This helps ensure the schema cache is up-to-date
 */
export const refreshDatabaseSchema = async (): Promise<void> => {
  try {
    console.log('Refreshing database schema...');
    
    // List of tables to query
    const tables = [
      'clients',
      'suppliers',
      'invoices',
      'invoice_items',
      'payments',
      'productions',
      'production_tasks',
      'samples',
      'sample_tasks',
      'express',
      'express_items',
      'express_stock',
      'express_stock_movements',
      'express_samples',
      'express_sample_items',
      'task_types',
      'todo_items',
      'chat_messages',
      'expenses',
      'expenses_categories'
    ];
    
    // Query each table to refresh schema
    const promises = tables.map(table => 
      supabase.from(table).select('id').limit(1)
    );
    
    await Promise.all(promises);
    
    console.log('Schema refresh complete');
  } catch (error) {
    console.error('Error refreshing schema:', error);
  }
};